import { render, staticRenderFns } from "./StudyLesson.vue?vue&type=template&id=1562b12a&scoped=true&"
import script from "./StudyLesson.vue?vue&type=script&lang=js&"
export * from "./StudyLesson.vue?vue&type=script&lang=js&"
import style0 from "./StudyLesson.vue?vue&type=style&index=0&id=1562b12a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1562b12a",
  null
  
)

export default component.exports